import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";

export default {
    mixins: [emCommonUtilMixin],
    computed: {
        //如果有customVuex则覆写此computed
        $_customVuexName() {
            return null;
        },
        $_emTableRef() {
            return 'emTable';
        },
        selectIds() {
            return this.checkedItems.join(",")
        },
        checkedItems() {
            //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
            return this.$store.state[this.modelName]["checkedItems" + (this.$_customVuexName == null ? '' : (this.firstUpperCase(this.$_customVuexName) + "Vo"))]
            // return this.$refs.emTable.checkedItems
        },
        $_checked() {
            return !this.$_notChecked;
        },
        $_checkedOne() {
            return !this.$_notCheckedOne;
        },
        $_notChecked() {
            return this.actionDisabled('select');
        },
        $_notCheckedOne() {
            return this.actionDisabled('selectOne');
        },
        tableRows() {
            return this.$store.state[this.modelName][this.$_customVuexName == null ? 'rows' : (this.$_customVuexName + 'Vo')]
        },
        checkedRows() {
            return this.tableRows.filter(f => this.checkedItems.includes(f.id));
        },
        checkedRow() {
            return this.$_checkedOne ? this.checkedRows[0] : null;
        },
        emTable() {
            if (this.mounted) {
                return this.$refs[this.$_emTableRef] ? this.$refs[this.$_emTableRef] : undefined;
            } else {
                return undefined;
            }
        },
        overCheckIsEnable() {
            return this.emTable && this.emTable.enableOverCheck;
        },
        overCheckedIds() {
            if (this.overCheckIsEnable) {
                return this.emTable.getOverCheckedIds();
            }
            return [];
        },
        $_overChecked() {
            return this.overCheckedIds.length > 0;
        }
    },
    data() {
        return {
            mounted: false
        }
    },
    mounted() {
        this.mounted = true;
    },
    methods: {
        firstUpperCase([first, ...rest]) {
            return first.toUpperCase() + rest.join('')
        },
        actionDisabled(type) {
            // 删除按钮在一条记录都没选的时候禁用
            if (type === "select") {
                // return this.$refs.emTable.checkedItems && this.$refs.emTable.checkedItems.length === 0;
                return this.checkedItems && this.checkedItems.length === 0;
            }
            // 编辑按钮只在选择了1条记录的时候可用，其他情况下禁用
            else if (type === "selectOne") {
                // return this.$refs.emTable.checkedItems && this.$refs.emTable.checkedItems.length !== 1;
                return this.checkedItems && this.checkedItems.length !== 1;
            }
        },
        downloadAllAttachment(attachmentIds, fileName) {
            if (this.hasCode(attachmentIds)) {
                if (!this.hasCode(fileName)) {
                    fileName = '批量下载' + new Date().valueOf();
                }
                let downEle = document.createElement('a');
                downEle.href = `${process.env.VUE_APP_EM_ADMIN_URL}/emAttachment/downloadAll?attachmentIds=${attachmentIds}&zipName=${fileName}`;
                downEle.setAttribute('download', fileName);
                document.body.appendChild(downEle);
                downEle.click();
                downEle.remove();
            } else {
                this.$message.warning('No attachment');
            }
        },
        downloadAllWithParamName(paramName, fileName) {
            let attachmentIds = this.checkedRows.filter(f => this.hasCode(f[paramName])).map(o => o[paramName]).join(",");
            this.downloadAllAttachment(attachmentIds, fileName);
        }
    }
}